import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { PayumoneyPaymentService } from 'src/app/core/services/payumoney-payment.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';
import { Constants } from 'src/app/_helpers/constant';
import { environment } from 'src/environments/environment';
import * as uuid from 'uuid';

@Component({
  selector: 'app-payment-subscription',
  templateUrl: './payment-subscription.component.html',
  styleUrls: ['./payment-subscription.component.scss']
})
export class PaymentSubscriptionComponent implements OnInit {
  public basicPlanIdTwo: any;
  public basicPlanIdThree: any;
  public submitObj: any;
  public basicPlanIdFour: any;
  public premiumPlanIdFive: any;
  public premiumPlanIdSix: any;
  public premiumPlanIdSeven: any;
  public currentUser: any;
  public url = Constants.url; //"https://secure.payu.in/_payment"//
  public basicId: any;
  public planArray: any;
  public description: any;
  public planName: any;
  public validity: any;
  public features: any;
  public totalAmount: any;
  public subscriptionPaymentId: number;
  public userSubscriptionId: number;
  public data: any;
  public isDropdownOpen: boolean = true;


  constructor(public paymentService: PayumoneyPaymentService,
    public httpClient: HttpClient,
    public subscriptionService: SubscriptionService,
    public route: ActivatedRoute,
    public router: Router,
    private toastService: ToastNotificationService
  ) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.basicId = +params.get('id');
      this.subscriptionPaymentId = +params.get('paymentId');
      this.userSubscriptionId = +params.get('userSubsId');
    });
    this.getAllSubscriptionPlans(this.basicId);
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.acccordianLogic();
  }
  
  acccordianLogic(){
    var acc = document.getElementsByClassName("accordion");
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      });
  }
  }

  

  /**
   * Set Payment form Data
   * @param planName 
   * @param totalAmount 
   */
  async setPaymentFormData(planName?: any, totalAmount?: any) {
    let obj = {
      key: "oZ7oo9",
      txnId: uuid.v4(),
      productinfo: planName,
      amount: totalAmount,
      surl: environment.apiUrl + "subscription/pay",
      furl: environment.apiUrl + "subscription/pay",
      phone: "1234567890",
      hash: "",
      udf1: String(this.currentUser.id),
      udf2: String(this.userSubscriptionId),
      udf3: String(this.subscriptionPaymentId),
      udf4: "",
      udf5: "",
      email: this.currentUser.email,
      firstName: this.currentUser.firstName,
      lastName: this.currentUser.lastName
    }
    
    this.submitObj = obj;
    console.log("submit OBJ",this.submitObj)
    await this.setHash();
  }

  /**
   * Set Hash code
   */
  setHash() {
    this.subscriptionService.getPaymentHash(this.submitObj, "").then((res) => {
      this.submitObj.hash = res
    });

    // this.submitObj.hash = "0d3f15771316a9b2fc2ff3a52305279dd3792a6078db05108c01b893ba619f87aa32e34df0275bc5528d1029a9473070cb5a108205efbef39f895439306757eb"
  }
  getPayment() {
    this.paymentService.getPaymentSuccess({}).then((res) => {
      this.router.navigate(['/auth/payment-success'])
    })
  }
  //get all main plans
  getAllSubscriptionPlans(basicId) {
    this.planName;
    this.subscriptionService.getPlansById({}, basicId).then((res) => {

      this.data = res;
      this.planArray = res.data;
      this.description = res.data.description;
      this.planName = res.data.planName;
      this.totalAmount = res.data.total_amount
      this.validity = res.data.validity;
      this.features = res.data.features;
      this.setPaymentFormData(this.planName, this.totalAmount);
    });
  }
  pay() {
    this.router.navigate[('/pages')]
  }
  onSuccessPayment(response) {
    this.toastService.toastMsg({
      title: "Success",
      content: "Success Payment" + " " + response,
    });
    // this.toastService.openSnackBar("Success Payment" + " " + response)
    if (response.url) {
      // Render PayUmoney payment gateway page
      window.location.href = response.url;
    }
  }

  onFailurePayment(error) {
    this.toastService.toastMsg({
      title: "Success",
      content: "Failure Payment" + " " + error,
    });
    // this.toastService.openSnackBar("Failure Payment" + " " + error)
  }









}
